import React, { useState } from "react";
import { Modal, Form, Button, Radio, Header } from "semantic-ui-react";

const ReportAccessModal = ({ onClose, onSubmit, ...props }) => {
  const [reason, setReason] = useState(undefined);

  return (
    <Modal size="small" closeIcon onClose={onClose} {...props}>
      <Modal.Header>Report Access Authorization</Modal.Header>
      <Modal.Content>
        <Header as="h4">
          Please select a reason for accessing this student's report:
        </Header>
        <Form>
          <Form.Field>
            <Radio
              label="I provide services and I am contributing to this report."
              name="reason"
              value="write"
              checked={reason === "write"}
              onChange={() => setReason("write")}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="I provide services and I am reading this report."
              name="reason"
              value="read"
              checked={reason === "read"}
              onChange={() => setReason("read")}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="I am reviewing this report for educational decision making."
              name="reason"
              value="audit"
              checked={reason === "audit"}
              onChange={() => setReason("audit")}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={reason === undefined}
          color="green"
          onClick={() => onSubmit(reason)}
        >
          Continue
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ReportAccessModal;
